<template>
  <!-- Swiper -->
  <!-- <div class="swiper mySwiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item,index) in dataList" :key="index">
        <div :style="{ backgroundImage: `url(${item.Img})` }" class="img"  @click="imgClick(item)">
            </div>
      </div>

    </div>
    <div class="swiper-pagination" style="left:25%"></div>
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div> -->
  <!-- <div class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item,index) in dataList" :key="index">
        <div class="swiper_card" @click="openDetail(item)">
          <img style="width:65%;height:65%;margin-top: 10%" src="../../assets/img/yellow.png">
          <div class="slide-box-small3">
            {{$t('home.caseNumber')}} {{ item }}
          </div>
        </div>

      </div>

    </div>

    <div class="swiper-button-next" style="width:2em;"></div>
    <div class="swiper-button-prev"></div>
  </div> -->
  <div class="swiper mySwiper_wantedPerson">
    <div class="swiper-wrapper">
      <!-- <div class="swiper-slide">Slide 1</div>
      <div class="swiper-slide">Slide 2</div>
      <div class="swiper-slide">Slide 3</div>
      <div class="swiper-slide">Slide 4</div>
      <div class="swiper-slide">Slide 5</div>
      <div class="swiper-slide">Slide 6</div>
      <div class="swiper-slide">Slide 7</div>
      <div class="swiper-slide">Slide 8</div>
      <div class="swiper-slide">Slide 9</div> -->
      <div class="swiper-slide" v-for="(item,index) in dataList" :key="index">
        <div class="swiper_card" @click="openDetail(item)">
          <img style="width:65%;height:65%;margin-top: 10%" src="../../assets/img/red.png">
          <div class="slide-box-small3" v-if="$i18n.locale == 'zh'">
            {{$t('home.caseNumber')}} {{ item }}
          </div>
          <div class="slide-box-small4" v-if="$i18n.locale == 'en'">
            {{$t('home.caseNumber')}} {{ item }}
          </div>
        </div>

      </div>
    </div>
    <!-- <div class="swiper-pagination"></div> -->
    <div class="swiper-button-next2" ></div>
    <div class="swiper-button-prev2"></div>
  </div>
</template>

<script>
import {getnewList} from "../../api/resouces";
import Swiper from 'swiper'

export default {
  data() {
    return {
      divHeight: '100',
      publicationDataList:[],
      publicationDataList1: [{title: "222"},{title: "222"},{title: ""},{title: ""},{title: ""}],//出版物数据列表
      currentIndex: 0,
      dataList: ['0000001', '0000002', '0000003', '0000004','0000005','0000006','0000007','0000008'],
      autoplayInterval: null,
      titleTree: [],
      pid: '',
      classId: 43,
      chgID: 0,
      imgList: [
        {
          url: "1"
        },
        {
          url: "2"
        },
        {
          url: "3"
        },
        {
          url: "4"
        },
      ]
    };
  },
  computed: {
    currentLargeImage() {
      return this.dataList.length > 0 ? this.dataList[this.currentIndex].Img : '';
    },
    currentSmallImage() {
      return this.dataList.length > 0
        ? this.dataList[(this.currentIndex + 1) % this.dataList.length].Img
        : '';
    },
  },
  created() {
    //   this.titleTree = JSON.parse(sessionStorage.getItem('titleTree'))
    //   getnewList({ classId: 73 }).then((res) => {
    //     res.data.forEach((item) => {
    //       if (item.Img) {
    //         item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
    //         this.dataList.push(item);
    //       }
    //     });
    //     getnewList({ classId: 74 }).then((res) => {
    //     res.data.forEach((item) => {
    //       if (item.Img) {
    //         item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
    //         this.dataList.push(item);
    //       }
    //     });
    //     // // 确保在数据加载完成后启动自动播放
    //     // if (this.dataList.length > 0) {
    //     //   this.startAutoplay();
    //     // }
    //   });

    //   });

  },
  mounted() {
    // this.getPublicationList()
    // setTimeout(() => {
      var swiper = new Swiper(".mySwiper_wantedPerson", {
      slidesPerView: 4,
      spaceBetween: 10,
      // centeredSlides: true,
      // spaceBetween: -12,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true,
      // },
      navigation: {
        nextEl: ".swiper-button-next2",
        prevEl: ".swiper-button-prev2",
      },
    })

    // }, 2000);
    setTimeout(() => {
        this.handleResize()
      }, 1000);

    let that = this
    window.addEventListener('resize', function () {
        that.handleResize();
    })
  },
  beforeDestroy() {
    let that = this
    window.removeEventListener('resize', function () {
      that.handleResize();
    })
  },
  methods: {
     //监测单个书本页面宽度
     handleResize() {
      let div = document.getElementById('myDiv');
      let width = div.offsetWidth;
      this.divHeight = width *1.4143
      console.log("width",width)
      console.log("this.divHeight",this.divHeight)

    },
    getPublicationList() {
      this.publicationDataList = []
      if (this.$i18n.locale == 'zh') {
        getnewList({classId: 33}).then((res) => {
          res.data.forEach((item) => {
            if (item.Img) {
              item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
              this.publicationDataList.push(item);
            }
          });
          if(this.publicationDataList.length<4){
        // for(let i=0;i<4-this.publicationDataList.length;i++){
        //   this.publicationDataList.push({title:"测试数据"})
        // }
      }
        })
      } else {
        getnewList({classId: 73}).then((res) => {
          res.data.forEach((item) => {
            if (item.Img) {
              item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
              this.publicationDataList.push(item);
            }
          });
          getnewList({classId: 74}).then((res) => {
            res.data.forEach((item) => {
              if (item.Img) {
                item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
                this.publicationDataList.push(item);
              }
            });
          });
      //     if(this.publicationDataList.length<4){
      //   for(let i=0;i<4-this.publicationDataList.length;i++){
      //     this.publicationDataList.push({title:"测试数据"})
      //   }
      // }
        });
      }


    },
    init() {
      let next = document.getElementById("next")
      let prev = document.getElementById('prev')
      const rotatePic = document.querySelector('.rotate_pic')
      const swiperBox = document.querySelector('.swiper_box')
      const swiperDiv = document.querySelectorAll('.swiper_box div')
      if (swiperDiv[0] != null) {
        swiperDiv[0].style.transform = `scale(1.2)`
        swiperDiv[0].style.transitionDuration = `1s`
      }

      // function render(index) {
      //     for (let i = 0; i < index; i++) {
      //         rotatePic.innerHTML += `<img src="images/rotate_${i + 1}.png">`
      //     }
      // }
      // render(swiperDiv.length)

      this.chgID = 0

      // next.addEventListener('click', () => {
      //     this.chgID++
      //     this.chgID = this.chgID > swiperDiv.length - 1 ? swiperDiv.length - 1 : this.chgID
      //     this.btnCommon()
      // })
      // prev.addEventListener('click', () => {
      //     this.chgID--
      //     this.chgID = this.chgID < 0 ? 0 : this.chgID
      //     this.btnCommon()
      // })

    },
    next() {
      const swiperDiv = document.querySelectorAll('.swiper_box div')
      this.chgID++
      // if (this.chgID + 2 == this.imgList.length) {
      //     let obj = JSON.parse(JSON.stringify(this.imgList[0]))
      //     this.imgList.push(obj)
      // }
      // this.chgID = this.chgID > swiperDiv.length - 2 ? swiperDiv.length - 2 : this.chgID
      this.btnCommon()
    },
    prev() {
      const swiperDiv = document.querySelectorAll('.swiper_box div')
      this.chgID--
      // this.chgID = this.chgID < 0 ? 0 : this.chgID
      this.btnCommon()
    },
    btnCommon() {
      const next = document.querySelector('#next')  //后一个按钮
      const prev = document.querySelector('#prev')    //前一个按钮
      const rotatePic = document.querySelector('.rotate_pic')
      const swiperBox = document.querySelector('.swiper_box')
      const swiperDiv = document.querySelectorAll('.swiper_box div')
      console.log("document.querySelector('.swiper_box')", swiperDiv[0].style)
      // next.style.pointerEvents = this.chgID == swiperDiv.length - 2 ? 'none' : 'auto'   //在划到最后一张或者第一张是否失焦
      // prev.style.pointerEvents = this.chgID == 0 ? 'none' : 'auto'
      // next.style.opacity = this.chgID == swiperDiv.length - 2 ? .6 : 1    //在划到最后一张或者第一张是否透明
      // prev.style.opacity = this.chgID == 0 ? .6 : 1
      // rotatePic.style.transform = `rotate(-${this.chgID * 45}deg)`
      // swiperBox.style.transform = `translateX(-${this.chgID * 100 / swiperDiv.length}%)`
      rotatePic.style.transform = this.chgID > swiperDiv.length - 2 ? `rotate(0deg)` : this.chgID < 0 ? `rotate(-${(swiperDiv.length - 2) * 45}deg)` : `rotate(-${this.chgID * 45}deg)`
      swiperBox.style.transform = this.chgID > swiperDiv.length - 2 ? `translateX(0%)` : this.chgID < 0 ? `translateX(-${(swiperDiv.length - 2) * 100 / swiperDiv.length}%)` : `translateX(-${this.chgID * 100 / swiperDiv.length}%)`
      this.chgID = this.chgID > swiperDiv.length - 2 ? 0 : this.chgID < 0 ? this.chgID = swiperDiv.length - 2 : this.chgID
      console.log("this.chgID", this.chgID)
      for (let i = 0; i < swiperDiv.length; i++) {
        if (i == this.chgID) {
          swiperDiv[i].style.transform = `scale(1.2)`
          swiperDiv[i].style.transitionDuration = `1s`
        } else {
          swiperDiv[i].style.transform = `scale(1)`
          swiperDiv[i].style.transitionDuration = `1s`

        }
      }
    },
    openDetile(info) {
      this.getPid(info.classId)
      this.$router.push({
        path: '/detail',
        query: {
          pid: this.pid,
          id: info.classId,
          detailId: info.id,
        }
      })
    },
    getPid(id) {
      this.titleTree = JSON.parse(sessionStorage.getItem('titleTree'))
      this.titleTree.children.forEach((item, index) => {
        if (item.children != null && item.children.length > 0) {
          item.children.forEach((item2, index2) => {
            if (item2.data.id == id) {
              this.pid = item2.data.columnPid
            } else {
              if (item2.children != null) {
                item2.children.forEach((ite, ind) => {
                  if (ite.data.id == id) {
                    this.pid = ite.data.columnPid
                  }
                })
              }
            }
          })
        }

      });
    },
    imgClick(obj) {
      console.log("obj", obj)
      this.titleTree.children.forEach((item, index) => {
        // console.log("item",item)
        if (item.children != null) {
          item.children.forEach((item2, index2) => {
            if (item2.data.id === obj.classId) {
              this.pid = item2.data.columnPid
            }
          })
        }
      });
      this.$router.push({
        path: '/detail',
        query: {
          pid: this.pid,
          id: obj.classId,
          detailId: obj.id,
        }
      })
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.dataList.length;
      this.resetAutoplay(); // 重置计时器
    },
    prevImage() {
      this.currentIndex = (this.currentIndex - 1 + this.dataList.length) % this.dataList.length;
      this.resetAutoplay(); // 重置计时器
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        // if((this.chgID+2) == this.dataList.length){
        this.next();
        // }
      }, 3000); // 自动播放间隔，单位毫秒
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    },
    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    },
//图片点击跳转事件
openDetail(item) {
      // this.getPid(info.classId)
      this.$router.push({
        path: '/personDetail',
        query: {
          personStatus: '1',
          id:item
        }
      })
    },
  },
  beforeDestroy() {
    this.stopAutoplay();
  },

};
</script>

<style scoped>
html,
body {
  position: relative;
  height: 100%;
}

body {
  background: #eee;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #000;
  margin: 0;
  padding: 0;
}

.swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.swiper-slide {
  /* width: 40px; */
  text-align: center;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* .swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
} */
/* .img{
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
} */
.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  /* transform: scale(0.6); */
}

.swiper-slide-active, .swiper-slide-duplicate-active {
  /* transform: scale(1); */
}

.swiper_card {
  width: 100%;
  /* height: 90%; */
  box-shadow: 1px 0px 5px 0px #bfbfbf;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
  background-color: #ffffff;
  text-align: center;
}

.slide-box-small3 {
  position: absolute;
  bottom: 10%;
  left: 10%;
  color: #000000;
  /* border-left: #fffefe 0.2em solid; */
  width: 80%;
  text-align: center;
  font-size: 5px;
  font-weight: bold;

}
.slide-box-small4 {
  position: absolute;
  bottom: 10%;
  left: 10%;
  color: #000000;
  /* border-left: #fffefe 0.2em solid; */
  width: 80%;
  text-align: center;
  font-size: 3px;
  font-weight: bold;


}

/* 默认隐藏切换按钮 */
.swiper-button-next2:hover,
.swiper-button-prev2:hover {
  opacity: 0.8;
}
 /* 默认隐藏切换按钮 */
 .swiper-button-next2{
  opacity: 0.3;
  background-image: url('../../assets/img/圆形箭头右.png') ;
  background-size: cover;
  height: 2.7em;
  width: 2.7em;
}
.swiper-button-prev2 {
  opacity: 0.3;
  background-image: url('../../assets/img/圆形箭头左.png');
  background-size: cover;
  height: 2.7em;
  width:2.7em;
}
.mySwiper_wantedPerson{
  position: relative;
}
/* .swiper-pagination{
    width: 100%;
  height: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/components/carousel/swiper_wantedPerson_phone.vue